var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconUtilities64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_10894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3 56.503V29.8481L32 45.2529L9.5 29.8481V56.503H54.3Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 25.8081L9.5 29.8301L31.9 45.2529L31.9139 45.2434L16 34.2529L16 25.8081ZM48.0001 34.1678L54.3 29.8301L48.0001 25.9319V34.1678Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 25.8081L16.6 25.8081C16.6 25.5905 16.4822 25.3899 16.2921 25.284C16.1019 25.178 15.8694 25.1834 15.6843 25.2979L16 25.8081ZM9.5 29.8301L9.18429 29.3199C9.01198 29.4265 8.90513 29.6129 8.90018 29.8155C8.89523 30.0181 8.99285 30.2094 9.15974 30.3243L9.5 29.8301ZM31.9 45.2529L31.5597 45.7471C31.7646 45.8882 32.0354 45.8882 32.2403 45.7471L31.9 45.2529ZM31.9139 45.2434L32.2541 45.7376C32.4166 45.6257 32.5137 45.4411 32.5139 45.2438C32.514 45.0465 32.4172 44.8618 32.2548 44.7497L31.9139 45.2434ZM16 34.2529L15.4 34.2529C15.4 34.4501 15.4968 34.6346 15.659 34.7467L16 34.2529ZM48.0001 34.1678H47.4001C47.4001 34.3906 47.5236 34.5952 47.7209 34.6989C47.9182 34.8026 48.1567 34.7884 48.3403 34.662L48.0001 34.1678ZM54.3 29.8301L54.6403 30.3243C54.8071 30.2094 54.9048 30.0181 54.8998 29.8155C54.8949 29.6129 54.788 29.4265 54.6157 29.3199L54.3 29.8301ZM48.0001 25.9319L48.3158 25.4217C48.1307 25.3072 47.8981 25.3019 47.708 25.4078C47.5179 25.5137 47.4001 25.7143 47.4001 25.9319H48.0001ZM15.6843 25.2979L9.18429 29.3199L9.81571 30.3404L16.3157 26.3183L15.6843 25.2979ZM9.15974 30.3243L31.5597 45.7471L32.2403 44.7588L9.84026 29.336L9.15974 30.3243ZM32.2403 45.7471L32.2541 45.7376L31.5736 44.7492L31.5597 44.7588L32.2403 45.7471ZM32.2548 44.7497L16.341 33.7592L15.659 34.7467L31.5729 45.7371L32.2548 44.7497ZM16.6 34.2529L16.6 25.8081L15.4 25.8081L15.4 34.2529L16.6 34.2529ZM48.3403 34.662L54.6403 30.3243L53.9597 29.336L47.6598 33.6736L48.3403 34.662ZM54.6157 29.3199L48.3158 25.4217L47.6844 26.4421L53.9843 30.3404L54.6157 29.3199ZM47.4001 25.9319V34.1678H48.6001V25.9319H47.4001Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 8.50293L48.0001 8.50293V34.1605L32.0001 45.3029L16 34.2529L16.0001 8.50293Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0181 17.1074H26.7614",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0181 13.4292H32.156",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7416 14.3696V22.903H44.0196L36.3708 34.6363V26.103H33.0928L40.7416 14.3696Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_10894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconUtilities64);
export default __webpack_public_path__ + "static/media/pictogramBeaconUtilities64.003d92abb9dfc29b6c45d28b5ba61d3f.svg";
export { ForwardRef as ReactComponent };